// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1r9wD","rootCenter":"LoadMoreObserver_rootCenter__mfgiZ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2mUWv"};